"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrand = exports.brand = void 0;
var Brand_1 = require("./Brand");
Object.defineProperty(exports, "brand", { enumerable: true, get: function () { return Brand_1.brand; } });
Object.defineProperty(exports, "getBrand", { enumerable: true, get: function () { return Brand_1.getBrand; } });
